import { render } from "./NordigenBanks.vue?vue&type=template&id=6a1a0f26&scoped=true"
import script from "./NordigenBanks.vue?vue&type=script&lang=js"
export * from "./NordigenBanks.vue?vue&type=script&lang=js"

import "./NordigenBanks.vue?vue&type=style&index=0&id=6a1a0f26&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1a0f26"]])

export default __exports__